module.exports = __webpack_public_path__ + "img/logo_arbitrum.3d13741f.png";